import { BodyMedium } from '@arnold/common';
import { ProductCode } from '@arnold/core';
import { TFunction } from 'react-i18next';
import { SurveyType } from './SurveyForm';
import { ActiveRespondents, AllowedTopicGroup, FormResults } from './formTypes';
import { ONE_TIME_PULSER_SURVEY_CREDIT_PRICE, ONE_TIME_SURVEY_CREDIT_PRICE } from '../../lib/creditPricing';
import { isPulserTopicGroup } from '../../lib/helpers';
import { UserQuery } from '../../generated/hooks';

type SurveyFormCreditProps = {
  organization: UserQuery['user']['organization'];
  formValues: FormResults;
  activeRespondents: ActiveRespondents;
  topicGroup?: AllowedTopicGroup;
  t: TFunction;
};

export const SurveyFormCreditCost = ({
  organization,
  formValues,
  activeRespondents,
  topicGroup,
  t,
}: SurveyFormCreditProps): JSX.Element => {
  const creditPrice = isPulserTopicGroup(topicGroup)
    ? ONE_TIME_PULSER_SURVEY_CREDIT_PRICE
    : ONE_TIME_SURVEY_CREDIT_PRICE;

  return (
    <>
      {organization?.productVersion?.product === ProductCode.Credits && formValues.type !== SurveyType.PUBLIC && (
        <BodyMedium style={{ fontWeight: 'bold', marginBottom: '1.25rem', marginTop: '1rem', alignSelf: 'center' }}>
          {t('totalCredits', {
            count:
              (formValues.whitelist && formValues.respondents.length > 0
                ? formValues.respondents.length
                : activeRespondents.length) * creditPrice,
          })}
        </BodyMedium>
      )}
    </>
  );
};
